var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyundaiValorDesafio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19601",
    "data-name": "Group 19601",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.025,
    height: 58.464,
    viewBox: "0 0 48.025 58.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9098",
    "data-name": "Path 9098",
    className: "cls-1",
    d: "M22.5,2V47.936H32.94V2Zm8.352,2.088H24.588v41.76h6.264Z",
    transform: "translate(15.085 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9099",
    "data-name": "Path 9099",
    className: "cls-1",
    d: "M4.5,11V38.144H14.94V11Zm8.352,2.088H6.588V36.056h6.264Z",
    transform: "translate(-4.5 7.792)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9100",
    "data-name": "Path 9100",
    className: "cls-1",
    d: "M16.5,44.672V5H26.94V44.672ZM18.588,7.088h6.264v35.5H18.588Z",
    transform: "translate(8.556 1.264)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9101",
    "data-name": "Path 9101",
    className: "cls-1",
    d: "M10.5,8V41.408H20.94V8Zm8.352,2.088H12.588V39.32h6.264Z",
    transform: "translate(2.028 4.528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9102",
    "data-name": "Path 9102",
    className: "cls-1",
    d: "M13.22,31.22a4.176,4.176,0,1,1,0-2.088h29.5a4.176,4.176,0,1,1,0,2.088Zm-1.956-1.044a2.088,2.088,0,1,1-2.088-2.088A2.088,2.088,0,0,1,11.264,30.176Zm35.5,2.088a2.088,2.088,0,1,0-2.088-2.088A2.088,2.088,0,0,0,46.76,32.264Z",
    transform: "translate(-3.956 24.112)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundaiValorDesafio);
export default __webpack_public_path__ + "static/media/hyundai-valor-desafio.a8e50d970b7b0a8c2b8888c63f4f4eb1.svg";
export { ForwardRef as ReactComponent };